<template>
  <BaseReadCardWidget
    heading="Facility Location"
    entity-label="Facility"
    @edit-click="handleEdit"
    :edit-auth-request="updateFacilityAR"
    :hide-default-actions="false"
    :no-data="!facilitySiteStore.facilitySite"
    @remove="$emit('remove')"
  >
    <template #default v-if="facilitySiteStore.facilitySite">
      <ReadField label="Location Address" :val="formatAddress(facilitySiteStore.facilitySite)" />

      <ReadField label="Assessor's Parcel Number (APN)" :val="facilitySiteStore.facilitySite.parcelNumber" />

      <ReadField label="UTM X" :val="facilitySiteStore.facilitySite.utmX" />
      <ReadField label="UTM Y" :val="facilitySiteStore.facilitySite.utmY" />
      <ReadField
        label="Horizontal Datum"
        :val="facilitySiteStore.facilitySite.horizontalDatumMurn"
        :lookup-format="LookupFormat.description"
      />
      <ReadField
        label="Collection Method"
        :val="facilitySiteStore.facilitySite.collectionMethodMurn"
        :lookup-format="LookupFormat.description"
      />
      <ReadField label="Location Taken" :val="facilitySiteStore.facilitySite.locationTaken" />
      <ReadField label="Location Metadata" :val="facilitySiteStore.facilitySite.locationMetadata" />
      <ReadField
        label="County"
        :val="facilitySiteStore.facilitySite.countyMurn"
        :lookup-format="LookupFormat.description"
      />
      <ReadField label="Mailing Address" :val="formatAddress(facilitySiteStore.facilitySite, { prefix: 'mail' })" />
    </template>
  </BaseReadCardWidget>
</template>

<script setup lang="ts">
import { routeNames } from "@/routes";
import { useFacilitySiteStore } from "@/views/facilitySite/facilitySiteStore";
import { LookupFormat, ReadField } from "@modernary/mui/components/read";
import { BaseReadCardWidget } from "@modernary/mui/components/widgetGrid";
import { AuthRequest, getUpdateResource } from "@modernary/mui/utils/authorization";
import { formatAddress } from "@modernary/mui/utils/filters";
import { watch } from "vue";
import { useRoute, useRouter } from "vue-router";

defineEmits<{
  remove: [];
}>();

/**
 * READ THIS BEFORE CHANGING EDIT OR DELETE FEATURES:
 * Some "Hub" features are TBD, so we're currently *copying* edit and delete features in both files.
 * Keep them in sync!
 */

const router = useRouter();
const route = useRoute();
const facilitySiteStore = useFacilitySiteStore();

if (!facilitySiteStore.facilitySite) {
  throw new Error("Facility site not found");
}

function handleEdit() {
  router.push({
    name: routeNames.facilitySite.edit,
    params: { id: route.params.id },
  });
}

const updateFacilityAR = new AuthRequest();

watch(
  () => facilitySiteStore.facilitySite,
  (newValue, oldValue) => {
    if (!newValue?.id) return;

    updateFacilityAR.permissionName = "UpdateFacilitySite";
    updateFacilityAR.resource = getUpdateResource(facilitySiteStore.authResource);
  },
  { immediate: true },
);
</script>
